import { Globe2, Menu, X } from "lucide-react";
import { useState } from "react";
import type { SiteLanguage } from "../lib/site";
import { localizedPath, switchLanguage } from "../lib/site";
import { staffSignInUrl } from "../../shared/hosts";

export function QoricanchaMark({ className = "" }: { className?: string }) {
  return <svg className={className} viewBox="0 0 72 62" role="img" aria-label="Sight Qoricancha arches">
    <path d="M7 54V17L16 8h40l9 9v37M4 17h64M16 54V28m20 26V28m20 26V28" />
    <path d="M16 35c0-8 4-12 10-12s10 4 10 12M36 35c0-8 4-12 10-12s10 4 10 12" />
  </svg>;
}

export function PublicHeader({ language, bookingUrl }: { language: SiteLanguage; bookingUrl?: string }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const home = language === "es" ? "/es" : "/";
  const labels = language === "es"
    ? { stay: "Alojamiento", about: "Nosotros", faq: "Preguntas", blog: "Guía de Cusco", book: "Reservar", staff: "Personal" }
    : { stay: "Stay", about: "About", faq: "FAQ", blog: "Cusco guide", book: "Book", staff: "Staff" };
  return <header className="public-header">
    <a className="brand" href={home} aria-label="Sight Qoricancha home"><span className="brand-mark"><QoricanchaMark /></span><span className="brand-wordmark">Sight <strong>Qoricancha</strong><small>Hostel · Cusco</small></span></a>
    <nav className={menuOpen ? "public-nav open" : "public-nav"} aria-label="Main navigation">
      <a href={`${home}#stay`} onClick={() => setMenuOpen(false)}>{labels.stay}</a>
      <a href={`${home}#about`} onClick={() => setMenuOpen(false)}>{labels.about}</a>
      <a href={`${home}#faq`} onClick={() => setMenuOpen(false)}>{labels.faq}</a>
      <a href={localizedPath("/blog", language)} onClick={() => setMenuOpen(false)}>{labels.blog}</a>
      <a className="staff-link" href={staffSignInUrl(window.location.hostname, language)}>{labels.staff}</a>
    </nav>
    <div className="header-actions">
      <div className="language-picker" aria-label={language === "es" ? "Elegir idioma" : "Choose language"}>
        <Globe2 size={17} aria-hidden="true" />
        <button className={language === "en" ? "active" : ""} onClick={() => switchLanguage("en")} lang="en" aria-pressed={language === "en"}>English</button>
        <span aria-hidden="true">/</span>
        <button className={language === "es" ? "active" : ""} onClick={() => switchLanguage("es")} lang="es" aria-pressed={language === "es"}>Español</button>
      </div>
      {bookingUrl && <a className="button button-primary header-book" href={bookingUrl} target="_blank" rel="noreferrer">{labels.book}</a>}
      <button className="mobile-menu" onClick={() => setMenuOpen(!menuOpen)} aria-label="Open menu">{menuOpen ? <X /> : <Menu />}</button>
    </div>
  </header>;
}
